import Phaser from "phaser";
import img_start from "../../assets/game/loading/btn-start.png";

import store from "../../vuex/store";
class GameScene extends Phaser.Scene {
  constructor(data, eventBus, levelTime, skipLoading, isMuted) {
    super({ key: "GameScene" });
    this.assetData = data;
    this.eventBus = eventBus;
    this.levelTime = levelTime;
    this.skipLoading = skipLoading; // 默认是加载，重新开始的时候是true
    this.gameOverText = null;
    this.succ = false;
    this.win = false;
    this.isInitMuted = isMuted;
    // bg * 3
    this.bgSky = null;
    this.bgSea = null;
    this.bgCloud = null;
    this.bgTexture = null;
    // kd
    this.keduo = null;
    this.keduo1 = null;
    this.flagbar = null;
    this.flag = null;
    // audio * 7
    this.bgMusic = null;
    this.right = null;
    this.alright = null;
    this.success = null;
    this.sfireworks = null;
    this.drown = null;
    this.p = false; // 第一次识别到失败了
    // 用做统一下降时间
    this.originY = 0;
    this.targetY = 0;
    this.velocityY = 0;
    this.currentTime = 0;
    // 资源加载完毕
    this.isStarted = false;
    this.ppstop = false; // 暂停的变量
    this.tmpTime = 0;
  }

  preload() {
    // 只加载必要的 loading 资源
    this.load.image(
      "loading1:ksy.png",
      this.assetData.animations.loading.image
    );
    this.load.spine(
      "loading1",
      this.assetData.animations.loading.json,
      this.assetData.animations.loading.atlas
    );
    this.load.image("btn_start", img_start);

    // 在初始阶段就加载背景音乐
    this.load.audio("bgMusic", this.assetData.audio.backgroundMusic);
  }

  create() {
    // 检查是否跳过加载
    if (this.skipLoading) {
      // 如果跳过加载，直接加载所有资源并进入游戏
      this.loadAllGameResources(() => {
        this.enterGame();
      });
    } else {
      // 显示加载界面
      this.createLoadingPage();

      // 在加载界面中加载其余游戏资源
      this.loadAllGameResources(() => {
        // 资源加载完成后，启用开始按钮
        if (this.startBtn) {
          this.startBtn.setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
          });
          // 添加视觉提示，表明可以开始游戏
          this.startBtn.setTint(0xffffff); // 恢复正常颜色
        }
      });
    }
  }

  loadingGameResources() {
    // keduo  一图3动作
    const texturesKey = "kd:keduo.png";
    this.load.image(texturesKey, this.assetData.animations.keduo.image);
    this.load.spine(
      "kd",
      this.assetData.animations.keduo.json,
      this.assetData.animations.keduo.atlas
    );

    // new cg --旗杆、旗子、烟花
    this.load.image("flagbar", this.assetData.successFlag.flagpole);
    this.load.image("flag", this.assetData.successFlag.flagImage);

    // new audio * 7
    this.load.audio("alright", this.assetData.audio.flyUpSound);
    this.load.audio("success", this.assetData.audio.winSound);
    this.load.audio("sfireworks", this.assetData.audio.fireworksSound);
    this.load.audio("drown", this.assetData.audio.failSound);
    this.load.audio("inputRightSound", this.assetData.audio.singleRightSound);
    this.load.audio("inputWrongSound", this.assetData.audio.singleWrongSound);

    this.eventBus.$on("setCorrect", this.onSetCorrect.bind(this));
    this.eventBus.$on("gameWin", this.onGameWin.bind(this));
    this.eventBus.$on("setPause", this.onSetPause.bind(this));
    this.eventBus.$on("inputRight", this.onInputRight.bind(this));
    this.eventBus.$on("inputWrong", this.onInputWrong.bind(this));
  }

  enterGame() {
    this.loadingNode && this.loadingNode.destroy();
    this.startBtn && this.startBtn.destroy();
    console.log('------enterGame: ', this.isInitMuted)
    const isMuted = this.isInitMuted;
    // 如果背景音乐未初始化，则初始化它
    if (!this.bgMusic) {
      this.bgMusic = this.sound.add("bgMusic");
      this.bgMusic.setLoop(true);
      this.bgMusic.play();
    }
    this.handleMute(!isMuted);
    this.createGameObjects();

    // 确保背景位置重置
    if (this.bgContainer) this.bgContainer.x = 0;
    if (this.cloudContainer) this.cloudContainer.x = 0;
    if (this.seaContainer) this.seaContainer.x = 0;
  }

  createGameObjects() {
    // 在这里初始化场景中的对象
    const gameWidth = this.sys.game.scale.width;
    const gameHeight = this.sys.game.scale.height;

    // 创建背景容器
    this.bgContainer = this.add.container(0, 0);
    this.bgContainer.setDepth(1);

    // 创建云层容器
    this.cloudContainer = this.add.container(0, 0);
    this.cloudContainer.setDepth(2);

    // 创建海洋和建筑容器
    this.seaContainer = this.add.container(0, 0);
    this.seaContainer.setDepth(3);

    // 加载天空背景（交替循环）
    this.sky1 = this.add.image(0, 0, "sky_1").setOrigin(0, 0);
    this.sky2 = this.add.image(this.sky1.width, 0, "sky_2").setOrigin(0, 0);
    this.sky3 = this.add.image(this.sky1.width + this.sky2.width, 0, "sky_1").setOrigin(0, 0); // 第三张为sky_1
    this.bgContainer.add([this.sky1, this.sky2, this.sky3]);
    
    // 记录天空背景的交替状态
    this.skyBackgrounds = [this.sky1, this.sky2, this.sky3];
    this.skyTextureIndex = 0; // 当前纹理索引 (0=sky_1, 1=sky_2)

    // 加载云层背景（两张拼接）
    this.cloud1 = this.add.image(0, 0, "clouds_1").setOrigin(0, 0);
    this.cloud2 = this.add
      .image(this.cloud1.width, 0, "clouds_2")
      .setOrigin(0, 0);
    this.cloudContainer.add([this.cloud1, this.cloud2]);

    // 加载海洋和建筑背景（交替循环）
    this.sea1 = this.add.image(0, 0, "sea_1").setOrigin(0, 0);
    this.sea2 = this.add.image(this.sea1.width, 0, "sea_2").setOrigin(0, 0);
    this.sea3 = this.add.image(this.sea1.width + this.sea2.width, 0, "sea_1").setOrigin(0, 0); // 第三张为sea_1
    this.seaContainer.add([this.sea1, this.sea2, this.sea3]);
    
    // 记录海洋背景的交替状态
    this.seaBackgrounds = [this.sea1, this.sea2, this.sea3];
    this.seaTextureIndex = 0; // 当前纹理索引 (0=sea_1, 1=sea_2)

    // 存储背景宽度，用于循环滚动
    this.bgWidth = this.sky1.width;

    this.keduo = this.add.spine(0, 0, "kd", "idle", true).setDepth(12);
    this.keduo.x = gameWidth / 2 - this.keduo.width * 0.7;
    // 起始点
    this.originY = this.sys.game.scale.height * (120 / 720);
    this.keduo.y = this.originY;

    this.keduo1 = this.add
      .spine(0, gameHeight * 0.2, "kd", "idle", true)
      .setDepth(11);
    this.keduo1.x = gameWidth / 2 - this.keduo.width * 0.5;
    this.keduo1.setAlpha(0);
    this.keduo.setAnimation(0, "1", true);
    // 落水点
    this.targetY = this.sys.game.scale.height * 0.45 - this.keduo.height / 2;
    this.velocityY = (this.targetY - this.originY) / this.levelTime;
    // 背景图
    this.bgTexture = this.textures.get("sky_1").getSourceImage();
    // 旗杆、旗子
    this.flagbar = this.add
      .sprite(gameWidth + 50, this.bgTexture.height * 0.54, "flagbar")
      .setScale(1)
      .setOrigin(0.6, 1)
      .setDepth(100);
    this.flag = this.add
      .sprite(gameWidth + 77, this.bgTexture.height * 0.54 - 10, "flag")
      .setScale(1)
      .setOrigin(0.6, 1)
      .setDepth(101);
    // 添加音频，备用
    this.alright = this.sound.add("alright");
    this.success = this.sound.add("success");
    this.sfireworks = this.sound.add("sfireworks");
    this.drown = this.sound.add("drown");
    this.inputRightSound = this.sound.add("inputRightSound");
    this.inputWrongSound = this.sound.add("inputWrongSound");

    this.events.on("mute", this.handleMute, this);
    this.eventBus.$emit("gameReady");
    this.isStarted = true;
  }

  handleMute(data) {
    console.log("game handleMute:", data);
    this.sound.mute = !data;
  }

  update(time, delta) {
    if (!this.isStarted) return;
    // 暂停的控制变量 -- 背景停住
    if (
      this.isStarted &&
      this.currentTime < 10000 &&
      !this.ppstop &&
      !this.win
    ) {
      this.tmpTime += delta;
      let moveY = this.velocityY * (delta / 1000);
      if (this.tmpTime < 500 && this.restart) {
        moveY = 0;
        delta = 0;
      } else if (this.restart) {
        this.restart = false;
      }
      this.currentTime += delta;
      this.keduo.y += moveY;
    }
    // 失败了，且是第一次识别到（this.p）
    if (this.keduo.y + 0.1 >= this.targetY && !this.p) {
      this.p = true;
      this.eventBus.$emit("setShowKeyboard", false);
      this.drown.play();
      this.keduo.setAnimation(0, "3", false);
      this.time.delayedCall(1000, () => {
        this.eventBus.$emit("gameFail");
      });
    }
    // 背景移动
    if (!this.ppstop && !this.win && !this.p) {
      // 移动背景容器
      this.bgContainer.x -= 3;
      this.cloudContainer.x -= 4;
      this.seaContainer.x -= 3;

      // 检查是否需要重置位置（循环滚动）
      this.checkSkyBackgroundReset();
      this.checkBackgroundReset(
        this.cloudContainer,
        this.cloud1.width + this.cloud2.width
      );
      this.checkSeaBackgroundReset();
    }

    // 单组输入成功的条件判断--鸟复位、音效、动效（气泡）、单组输入成功变量还原
    if (this.win) {
      // 调整旗子位置
      if (this.flagbar.x > this.sys.game.scale.width * 0.4) {
        const tmpDis = this.flagbar.x - this.sys.game.scale.width * 0.4;
        this.flagbar.x = this.flagbar.x - (tmpDis > 8 ? 8 : tmpDis);
        this.flag.x = this.flag.x - (tmpDis > 8 ? 8 : tmpDis);

        // 胜利状态下继续滚动背景
        this.bgContainer.x -= 3;
        this.cloudContainer.x -= 4;
        this.seaContainer.x -= 3;

        // 检查是否需要重置位置
        this.checkSkyBackgroundReset();
        this.checkBackgroundReset(
          this.cloudContainer,
          this.cloud1.width + this.cloud2.width
        );
        this.checkSeaBackgroundReset();
      } else {
        this.flagbar.x = this.sys.game.scale.width * 0.4;
        this.flag.x = this.sys.game.scale.width * 0.4 + 27;
        this.keduo1.x = this.sys.game.scale.width / 2 - this.keduo.width * 0.5;
        if (this.flag.y > this.flagbar.y - this.flagbar.height + 51)
          this.flag.y = this.flag.y - 5;
        else if (!this.succ) {
          this.succ = true;
          store.dispatch("keyboardGame/gameOver", true);
        }

        // 胜利后只有云继续移动
        this.cloudContainer.x -= 0.5;
        this.checkBackgroundReset(
          this.cloudContainer,
          this.cloud1.width + this.cloud2.width
        );
      }
    }
  }

  // 添加新方法检查并重置背景位置
  checkBackgroundReset(container, width) {
    // 当第一张图片完全移出屏幕时，将容器重置到初始位置
    if (container.x <= -width) {
      container.x = 0;
    }
  }

  checkSkyBackgroundReset() {
    // 当第一张图片完全移出屏幕时，进行交替循环
    if (this.bgContainer.x <= -this.skyBackgrounds[0].width) {
      // 计算超出距离 - 容器继续移动超过触发点的距离
      const overflowDistance = this.bgContainer.x + this.skyBackgrounds[0].width;
      
      // 移动第一张图片到最后
      const firstImage = this.skyBackgrounds.shift();
      this.skyBackgrounds.push(firstImage);
      
      // 重新排列图片位置 - 基于各自的实际宽度
      let currentX = 0;
      this.skyBackgrounds.forEach((image, index) => {
        image.x = currentX;
        currentX += image.width;
      });
      
      // 交替纹理：更新最后一张图片的纹理
      this.skyTextureIndex = this.skyTextureIndex === 0 ? 1 : 0;
      const newTexture = this.skyTextureIndex === 0 ? "sky_1" : "sky_2";
      this.skyBackgrounds[this.skyBackgrounds.length - 1].setTexture(newTexture);
      
      // 保持连续性：重置容器位置并保持超出距离
      this.bgContainer.x = overflowDistance;
    }
  }

  checkSeaBackgroundReset() {
    // 当第一张图片完全移出屏幕时，进行交替循环
    if (this.seaContainer.x <= -this.seaBackgrounds[0].width) {
      // 计算超出距离 - 容器继续移动超过触发点的距离
      const overflowDistance = this.seaContainer.x + this.seaBackgrounds[0].width;
      
      // 移动第一张图片到最后
      const firstImage = this.seaBackgrounds.shift();
      this.seaBackgrounds.push(firstImage);
      
      // 重新排列图片位置 - 基于各自的实际宽度
      let currentX = 0;
      this.seaBackgrounds.forEach((image, index) => {
        image.x = currentX;
        currentX += image.width;
      });
      
      // 交替纹理：更新最后一张图片的纹理
      this.seaTextureIndex = this.seaTextureIndex === 0 ? 1 : 0;
      const newTexture = this.seaTextureIndex === 0 ? "sea_1" : "sea_2";
      this.seaBackgrounds[this.seaBackgrounds.length - 1].setTexture(newTexture);
      
      // 保持连续性：重置容器位置并保持超出距离
      this.seaContainer.x = overflowDistance;
    }
  }

  // 一组输入正确
  onSetCorrect() {
    this.alright.play(); // 音效
    this.keduo.y = this.originY; // 起飞
    this.currentTime = 0; // 重新计时
    this.restart = false;
  }

  // 游戏成功
  onGameWin() {
    // 标注一个变量，通知update里面的成功操作，第一次识别到成功
    if (!this.win) {
      this.keduo.setAnimation(0, "2", true);
      this.keduo1.setAlpha(1);
      this.keduo1.setAnimation(0, "4", true);
      this.win = true;
      this.sfireworks.setLoop(true);
      this.sfireworks.play();
      this.success.play();
    }
  }

  // 游戏暂停
  onSetPause(data) {
    this.ppstop = data;
    this.restart = !data;
    this.tmpTime = 0;
    if (data) {
      this.bgMusic.pause();
    } else {
      this.bgMusic.resume();
    }
  }

  onInputRight() {
    this.inputRightSound.play();
  }

  onInputWrong() {
    this.inputWrongSound.play();
  }

  createLoadingPage() {
    this.loadingNode = this.add.spine(0, 0, "loading1", "1");
    this.loadingNode.play("animation", true);

    // 屏幕底部水平居中
    this.startBtn = this.add
      .sprite(
        this.sys.game.scale.width / 2,
        this.sys.game.scale.height - 120,
        "btn_start"
      )
      .setOrigin(0.5, 0.5)
      .setScale(1)
      .setDepth(100)
      .setTint(0x888888); // 设置灰色，表示按钮不可用

    // 初始时不设置交互，等资源加载完成后再启用

    // 添加加载中文本
    this.loadingText = this.add
      .text(
        this.sys.game.scale.width / 2,
        this.sys.game.scale.height - 180,
        "资源加载中...",
        {
          fontFamily: '"Roboto", sans-serif',
          fontSize: "24px",
          fill: "#ffffff",
        }
      )
      .setOrigin(0.5)
      .setDepth(100);

    // 背景音乐--循环播放
    // 从游戏配置中获取 vuex 状态
    this.bgMusic = this.sound.add("bgMusic");
    this.bgMusic.setLoop(true);
    this.bgMusic.play();
    const isMuted = this.sys.game.config.isMuted;
    console.log("isMuted xx2:", isMuted);
    if (!isMuted) {
      this.handleMute(false);
    } else {
      this.handleMute(true);
    }
  }

  loadAllGameResources(callback) {
    // 添加加载进度条
    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x222222, 0.8);
    progressBox.fillRect(
      this.sys.game.scale.width / 2 - 160,
      this.sys.game.scale.height / 2 - 25,
      320,
      50
    );

    // 进度文本
    const percentText = this.add
      .text(
        this.sys.game.scale.width / 2,
        this.sys.game.scale.height / 2,
        "0%",
        {
          fontFamily: '"Roboto", sans-serif',
          fontSize: "20px",
          fill: "#ffffff",
        }
      )
      .setOrigin(0.5);

    // 监听加载进度
    this.load.on("progress", (value) => {
      progressBar.clear();
      progressBar.fillStyle(0xffffff, 1);
      progressBar.fillRect(
        this.sys.game.scale.width / 2 - 150,
        this.sys.game.scale.height / 2 - 15,
        300 * value,
        30
      );
      percentText.setText(parseInt(value * 100) + "%");
    });

    // 加载完成时
    this.load.on("complete", () => {
      progressBar.destroy();
      progressBox.destroy();
      percentText.destroy();
      if (this.loadingText) {
        this.loadingText.destroy();
      }

      // 向外部发送加载完成事件
      this.game.events.emit("loadComplete");
      
      // 执行回调
      if (callback) callback();
    });

    // 加载背景图片（两张一组）
    this.load.image("sky_1", this.assetData.backgrounds.sky_1);
    this.load.image("sky_2", this.assetData.backgrounds.sky_2);
    this.load.image("clouds_1", this.assetData.backgrounds.cloud_1);
    this.load.image("clouds_2", this.assetData.backgrounds.cloud_2);
    this.load.image("sea_1", this.assetData.backgrounds.seaCity_1);
    this.load.image("sea_2", this.assetData.backgrounds.seaCity_2);

    // 加载可多
    const texturesKey = "kd:keduo.png";
    this.load.image(texturesKey, this.assetData.animations.keduo.image);
    this.load.spine(
      "kd",
      this.assetData.animations.keduo.json,
      this.assetData.animations.keduo.atlas
    );

    // 加载旗杆、旗子
    this.load.image("flagbar", this.assetData.successFlag.flagpole);
    this.load.image("flag", this.assetData.successFlag.flagImage);

    // 加载音效
    this.load.audio("alright", this.assetData.audio.flyUpSound);
    this.load.audio("success", this.assetData.audio.winSound);
    this.load.audio("sfireworks", this.assetData.audio.fireworksSound);
    this.load.audio("drown", this.assetData.audio.failSound);
    this.load.audio("inputRightSound", this.assetData.audio.singleRightSound);
    this.load.audio("inputWrongSound", this.assetData.audio.singleWrongSound);

    // 开始加载
    this.load.start();

    // 绑定事件监听器
    this.eventBus.$on("setCorrect", this.onSetCorrect.bind(this));
    this.eventBus.$on("gameWin", this.onGameWin.bind(this));
    this.eventBus.$on("setPause", this.onSetPause.bind(this));
    this.eventBus.$on("inputRight", this.onInputRight.bind(this));
    this.eventBus.$on("inputWrong", this.onInputWrong.bind(this));

    if (this.startBtn) {
      this.startBtn.setInteractive({
        useHandCursor: true,
        pixelPerfect: true,
      });

      this.startBtn.on("pointerdown", () => {
        console.log("点击了开始按钮");
        this.enterGame();
      });
    }
  }
}

export default GameScene;
